import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";

import CustomAutoCompleteCartaPorte from "../../../../components/formik/CustomAutoCompleteCartaPorte";
import CustomAutoCompleteCustomerSR from "../../../../components/formik/CustomAutoCompleteCustomerSR";
import moment from "moment-timezone";

const CartaPorteFormFields = ({
  formik,
  conceptoFactura,
  setconceptoFactura,
  fecha,
  setFecha,
  folios,
  series,
  razonSocial,
  setCustomerId,
  findPaymentFormByCoincidence,
  findPaymentMethodByCoincidence,
  findCustomerSocialReasonByCoincidence,
  findCFDIByCoincidence,
  findFiscalRegimesByCoincidence,
  onNewCustomerClick,
  razonSocialAPI,
}) => {
  const { values, errors, touched, handleChange } = formik;

  const maxDate = moment().format("YYYY-MM-DD"); // hoy
  const minDate = moment().subtract(3, "days").format("YYYY-MM-DD"); // hace 2 días

  return (
    <>
      <Row className="mb-3">
        {/* <Form.Group as={Col} md="4" controlId="conceptoFactura">
          <Form.Label>Concepto *</Form.Label>
          <Form.Control
            type="text"
            name="conceptoFactura"
            value={values.conceptoFactura}
            onChange={(e) => {
              setconceptoFactura(e.target.value);
              handleChange(e);
            }}
            isInvalid={touched.conceptoFactura && !!errors.conceptoFactura}
          />
          <Form.Control.Feedback type="invalid">
            {errors.conceptoFactura}
          </Form.Control.Feedback>
        </Form.Group> */}

        <Form.Group as={Col} md="4" controlId="fecha">
          <Form.Label>Fecha</Form.Label>
          <Form.Control
            type="date"
            name="fecha"
            value={values.fecha}
            onChange={(e) => {
              setFecha(e.target.value);
              handleChange(e);
            }}
            isInvalid={touched.fecha && !!errors.fecha}
            min={minDate}
            max={maxDate}
          />
          <Form.Control.Feedback type="invalid">
            {errors.fecha}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md="4" controlId="folio">
          <Form.Label>Folio</Form.Label>
          <Form.Select
            name="folio"
            value={values.folio}
            onChange={handleChange}
            isInvalid={touched.folio && !!errors.folio}
          >
            <option value="">Selecciona un folio</option>
            {folios.map((folio) => (
              <option key={folio.id} value={folio.prefix}>
                {folio.type} - {folio.prefix}
              </option>
            ))}
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            {errors.folio}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md="4" controlId="serie">
          <Form.Label>Serie</Form.Label>
          <Form.Select
            name="serie"
            value={values.serie}
            onChange={handleChange}
            isInvalid={touched.serie && !!errors.serie}
          >
            <option value="">Selecciona una serie</option>
            {series.map((serie) => (
              <option key={serie.id} value={serie.prefix}>
                {serie.type} - {serie.prefix}
              </option>
            ))}
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            {errors.serie}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      <Row className="mb-3">
        <Form.Group as={Col} md="3" controlId="paymentFormId">
          <CustomAutoCompleteCartaPorte
            formik={formik}
            field="paymentFormId"
            label="Método de Pago"
            searchFunction={findPaymentFormByCoincidence}
          />
          {errors.paymentFormId && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.paymentFormId}
            </Form.Control.Feedback>
          )}
        </Form.Group>

        <Form.Group as={Col} md="3" controlId="paymentMethodId">
          <CustomAutoCompleteCartaPorte
            formik={formik}
            field="paymentMethodId"
            label="Forma de Pago"
            searchFunction={findPaymentMethodByCoincidence}
          />
          {errors.paymentMethodId && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.paymentMethodId}
            </Form.Control.Feedback>
          )}
        </Form.Group>

        <Form.Group as={Col} md="6" controlId="customerId">
          <Row className="g-2 align-items-end">
            <Col xs={8}>
              <CustomAutoCompleteCustomerSR
                formik={{
                  ...formik,
                  setFieldValue: (field, value) => {
                    setCustomerId(value);
                    formik.setFieldValue(field, value);
                  },
                }}
                field="customerId"
                label="Cliente"
                searchFunction={(word) =>
                  findCustomerSocialReasonByCoincidence(razonSocialAPI, word)
                }
                showId={false}
              />
            </Col>
            <Col xs={4} className="d-flex align-items-center">
              <Button
                variant="outline-success"
                onClick={onNewCustomerClick}
                className="w-100"
              >
                <i className="fas fa-user-plus me-2"></i>
                Nuevo cliente
              </Button>
            </Col>
          </Row>
          {errors.customerId && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.customerId}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Row>

      <Row className="mb-3">
        <Form.Group as={Col} md="6" controlId="cfdiId">
          <CustomAutoCompleteCartaPorte
            formik={formik}
            field="cfdiId"
            label="CFDI"
            searchFunction={findCFDIByCoincidence}
          />
          {errors.cfdiId && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.cfdiId}
            </Form.Control.Feedback>
          )}
        </Form.Group>

        <Form.Group as={Col} md="6" controlId="fiscalRegimeId">
          <CustomAutoCompleteCartaPorte
            formik={formik}
            field="fiscalRegimeId"
            label="Régimen Fiscal"
            searchFunction={findFiscalRegimesByCoincidence}
            descriptionField="description"
          />
          {errors.fiscalRegimeId && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.fiscalRegimeId}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Row>
    </>
  );
};

export default CartaPorteFormFields;
